// TODO: This component should be reduced to a message dialog
// The input and select options should removed - use FormDialogModal instead for those use cases
import { useState } from "react"

import { Button } from "web/components"
import { Select } from "web/components/Form/Controls"
import useAutoFocusInput from "web/hooks/behaviour/useAutoFocusInput"

export default function DialogModal({
  respond,
  prompt,
  commands = [{ label: "OK", response: true }],
  input = false,
  inputPlaceholder = "",
  options,
  isInputRequired = false,
}) {
  const hasOptions = options !== undefined

  const [inputValue, setInputValue] = useState(
    input ? inputPlaceholder : hasOptions ? options[0] : undefined
  )
  const { inputRef } = useAutoFocusInput()

  function handleKeyUp(e) {
    const carriageReturn = 13

    if (e.which === carriageReturn) {
      respond({ response: true, inputValue })
    }
  }

  return (
    <>
      <div className="modal-content-above-commands dialog-prompt">
        <div>{prompt}</div>
        <div className="mt-1.5 w-full">
          {input && (
            <input
              type="text"
              ref={inputRef}
              className="form-control"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyUp={handleKeyUp}
            />
          )}
          {options && (
            <Select
              value={inputValue}
              isRequired={true}
              options={options}
              onChange={setInputValue}
            />
          )}
        </div>
      </div>
      <div className="modal-commands">
        <div className="right-buttons">
          {commands.map((command) => {
            const isNotCancelButton = command.label !== "Cancel"

            return (
              <Button
                testId={`button-dialog-modal-${command.label}`}
                key={command.label}
                variant={command.variant}
                disabled={isInputRequired && isNotCancelButton && !inputValue}
                onClick={() =>
                  respond({ response: command.response, inputValue })
                }
              >
                {command.label}
              </Button>
            )
          })}
        </div>
      </div>
    </>
  )
}
